// import index from './react/index.jsx'
import * as config from "./config";
import MenuTrigger from "./module/menuTrigger";
import { HomeRentalSlide, PersonalSlide } from './module/swipter'
import BackgroundChanger from './module/background-changer'

require('./module/common')
require('./module/suction')
require('./module/modaal')
require('./module/sticky-header')
require('./module/mouse-stalker')
require('./module/modal-video')
// require('./module/swipter')
// require('./module/personal-swipter')
require('./module/inifiniteSlide')
require('./module/loading')
require('./module/movoto-scroll')
require('./module/setScrollbarWidth')
require('./module/gsap')
require('./module/gsap-accordion')
require('./module/scroll-navigation')
require('./module/getUrl')
// require('./module/sticking-hover')

//仮設置
// require('./module/bkcurve')

// import Suction from "./module/suction";

const modules = [
  MenuTrigger,
  HomeRentalSlide,
  PersonalSlide,
  BackgroundChanger
]

const instance = []

;[].forEach.call(modules, m => {
  instance.push(new m())
})

window[config.namespace] = {
  instance
}
